/* eslint-disable camelcase */

import { Record } from 'immutable'

export const Experience = Record({
  id: null, // integer
  cover: '/images/ambassador_cover_default.png', // string
  description: null, // string
  startsOn: null, // date
  endsOn: null, // date
  location: null, // string
  logo: '/images/default-logo-tour.svg', // string
  name: null // string
})

export const deserializeExperience = (experience) => {
  const { starts_on, ends_on, ...props } = experience

  return new Experience({
    ...props,
    startsOn: starts_on,
    endsOn: ends_on
  })
}
